<template>
    <CardRh :processando="processando" titulo="AULAS CADASTRADAS">
        <div class="aula-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaAula" class="form-label">Pesquisar</label>
                        <input id="pesquisaAula" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Turma, disciplina ou instrutor" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMinAula" class="form-label">Data Minima</label>
                        <input id="dataMinAula" v-model="data_min" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMaxAula" class="form-label">Data Maxima</label>
                        <input id="dataMaxAula" v-model="data_max" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="instrutorCpfAula" class="form-label">Instrutor CPF</label>
                        <input id="instrutorCpfAula" v-model="instrutorCPF" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF do instrutor" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="controladorCpfAula" class="form-label">Controlador CPF</label>
                        <input id="controladorCpfAula" v-model="controladorId" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF do controlador" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="pelotaoAula" class="form-label">Pelotão</label>
                        <input id="pelotaoAula" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotão" />
                    </div>  
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="turmaAula" class="form-label">Turma</label>
                        <input id="turmaAula" v-model="turma" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Turma" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="disciplinaAula" class="form-label">Disciplina</label>
                        <input id="disciplinaAula" v-model="disciplina" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Disciplina" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="status">
                        <label for="statusAula" class="form-label">Status</label>
                        <Multiselect id="statusAula" @change="refreshTable" :options="status_select"
                            :searchable="true" v-model="status_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="numeroAula" class="form-label">Número</label>
                        <input id="numeroAula" v-model="numero" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Número da aula" />
                    </div> 
                    <div class="col-12 col-lg-2 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm mt-5" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:80px">Id</th>
                    <th style="max-width:80px">Nº</th>
                    <th>Disciplina</th>
                    <th>Pel</th>
                    <th>Turma</th>
                    <th>Data</th>
                    <th>Inicio</th>
                    <th>Instrutor</th>
                    <th>Situacao</th>
                    <th style="min-width:120px">Natureza</th>
                    <th class="text-center" v-if="hasPermissao" style="min-width:200px">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaService from "@/service/v1/sigap/AulaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "AulaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class AulaIndex extends IndexModelTable {
    public status_id: any = 1;
    public status: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public instrutorCPF = "";
    public controladorId = "";
    public pelotao = "";
    public numero = "";
    public turma = "";
    public disciplina = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEdicao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.instrutorCPF = "";
        this.controladorId = "";
        this.status_id = null;
        this.pelotao = "";
        this.numero = "";
        this.turma = "";
        this.disciplina = "";
        this.refreshTable();
    }

    created() {
        this.data_min = this.hj;
        this.service = new AulaService();
        this.getStatus();
        this.config.order = [[5, "desc"],[6, "desc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    instrutorCPF: this.instrutorCPF,
                    ControladorId: this.controladorId,
                    status: this.status_id,
                    pelotao: this.pelotao,
                    numero: this.numero,
                    disciplina: this.disciplina,
                    turma: this.turma,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "id", name: "id", searchable: false },
            { data: "numero", name: "numero", class: "desktop", searchable: false },
            { data: "disciplina", name: "disciplina", searchable: false },
            { data: "aulaDisciplina", name: "auladisciplina", searchable: false },
            { data: "turma", name: "turma", class: "desktop", searchable: false },
            { data: "data", name: "data", class: "desktop", searchable: false },
            { data: "inicio", name: "inicio", class: "desktop", searchable: false },
            { data: "instrutor", name: "instrutor", class: "desktop", searchable: false },
            { data: "status", name: "status", searchable: false, class: "text-center desktop" },
            { data: "natureza", name: "natureza", searchable: false, class: "text-center desktop" },
        ];
        this.config.columnDefs = [
            {
                targets: 1,
                render: function (row, type, val) {
                    return row + "/" + val.disciplina?.cargaHoraria;
                }
            },
            {
                targets: 2,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 3,
                render: function (row) {
                    return row != null ? row.pelotao : "";
                }
            },
            {
                targets: 4,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 7,
                render: (row) => {
                    return row != null ? row.nome : "";
                },
            },
            {
                targets: 8,
                render: (row) => {
                    return row.nome ?? "";
                },
            },
            {
                targets: 9,
                render: (row) => {
                    return row.nome ?? "";
                },
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 10,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-aula ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';

                        if (val.status.id < 3 && this.hasPermissaoEdicao) {
                            texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-editar-aula ' + buttom + ' title="Editar"><i class="fa fa-edit"></i></button>';
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir-aula ' + buttom + '><i class="fa fa-trash"></i></button>';
                        }
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-show-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_aulas_show", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
        $("[btn-editar-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_aulas_editar", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
        $("[btn-excluir-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.excluirModelo(id);
        });
    }
}
</script>

<style scoped>
.aula-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>

 